import api from './base';

/**
 * Get the user's cart
 * @returns {Promise} - API response
 */
export const getCart = async () => {
  const response = await api.get('/cart');
  return response.data;
};

/**
 * Add an item to the cart
 * @param {Object} itemData - Item data (productId, quantity, color)
 * @returns {Promise} - API response
 */
export const addToCart = async (itemData) => {
  const response = await api.post('/cart/add', itemData);
  return response.data;
};

/**
 * Update cart item quantity
 * @param {Object} itemData - Item data (productId, quantity, color)
 * @returns {Promise} - API response
 */
export const updateCartItem = async (itemData) => {
  const response = await api.put('/cart/update', itemData);
  return response.data;
};

/**
 * Remove an item from the cart
 * @param {String} productId - Product ID
 * @param {String} color - Color value (can be null)
 * @returns {Promise} - API response
 */
export const removeFromCart = async (productId, color = null, sizeLabel = null) => {
  const params = new URLSearchParams();
  if (color) params.set('color', color);
  if (sizeLabel) params.set('sizeLabel', sizeLabel);
  const query = params.toString() ? `?${params.toString()}` : '';
  const response = await api.delete(`/cart/remove/${productId}${query}`);
  return response.data;
};

/**
 * Clear the entire cart
 * @returns {Promise} - API response
 */
export const clearCart = async () => {
  const response = await api.delete('/cart/clear');
  return response.data;
};

/**
 * Sync guest cart with user cart after login
 * @param {Object} guestCartData - Guest cart data
 * @returns {Promise} - API response
 */
export const syncCart = async (guestCartData) => {
  const response = await api.post('/cart/sync', { guestCart: guestCartData });
  return response.data;
};